export default "<app-list-api-connections class=\"flex-column v-100 h-100 flex-grow-1\"></app-list-api-connections>\n";